<list-template>

	<div class="row">
		<div class="col-12">
			<archive-filters />
		</div>
	</div>

	<div class="row">
		<div class="col-12">
			<archive-table />
		</div>
	</div>

</list-template>